module.exports = __webpack_public_path__ + "img/profile-pic.a0c4bca8.png";